// How well each tier converts, as its own card.
//
// The Tiering card above answers where the conversions come from, which a tier
// can win purely by holding most of the leads. This is the other question, and
// keeping them apart is deliberate: the volume bar is a control and this is not,
// so folding the rates into its bands would put an editable number and a derived
// one in the same place.
//
// Fed from the same ladder as the control, so the rates move as a boundary is
// dragged rather than after a round trip. Markup and CSS are the tree page's
// precision bars, so the same reading looks the same on both screens.
import React from 'react';
import { observer } from 'mobx-react';

import { TierOutcome } from './scoreLadder';
import '../trees/treePerformanceCharts.css';

const rate = (value: number) => `${value.toFixed(1)}%`;

/**
 * Under this the label does not fit inside the bar and moves outside it, rather
 * than disappearing: there are only four rows and each row's number is the point
 * of it.
 */
const MIN_INSIDE_LABEL = 24;

function PrecisionBars({ tiers }: { tiers: TierOutcome[] }) {
  const best = Math.max(...tiers.map((tier) => tier.rate));

  return (
    <div>
      {tiers.map((tier) => {
        // Scaled against the best converting tier so the top bar fills its
        // track. A flat 0 to 100 axis draws every bar as a sliver at the base
        // rates fit models run at, which is the case this exists to make
        // readable.
        const width = best > 0 ? (tier.rate / best) * 100 : 0;
        return (
          <div className="tpf-rate-row" key={tier.segment}>
            <span className="tpf-rate-label">{tier.label}</span>
            <div className="tpf-rate-track">
              <span
                className="tpf-rate-fill"
                style={{ width: `${width}%`, background: tier.color }}
              >
                {width >= MIN_INSIDE_LABEL && (
                  <span
                    className="tpf-rate-value"
                    style={{ color: tier.textColor }}
                  >
                    {rate(tier.rate)}
                  </span>
                )}
              </span>
              {width < MIN_INSIDE_LABEL && (
                <span className="tpf-rate-value tpf-rate-value--outside">
                  {rate(tier.rate)}
                </span>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default observer(PrecisionBars);
